var map = {
	"./1.png": 2049,
	"./2.png": 4618,
	"./3.png": 6531,
	"./4.png": 9132,
	"./5.png": 5045,
	"./6.png": 3566,
	"./7.png": 3063,
	"./8.png": 6704,
	"./9.png": 6601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 809;